import { Disclosure, Transition } from "@headlessui/react";
import clsx from "clsx";
import { FCC } from "types";

import { ChevronLeft } from "@/assets/icons/ds";

interface Props {
  className?: string;
  label: string;
  canOpen?: boolean;
  /** Whether the panel starts expanded. Defaults to true (existing behaviour). */
  defaultOpen?: boolean;
}

export const Accordion: FCC<Props> = ({
  className,
  label,
  canOpen = true,
  defaultOpen = true,
  children,
}) => {
  return (
    <div
      className={clsx("w-full rounded-md bg-surface-quaternary p-4", className)}
    >
      <Disclosure defaultOpen={defaultOpen}>
        {({ open }) => (
          <>
            <div
              data-testid="accordion-header"
              className="flex w-full items-center justify-between gap-4"
            >
              <h6 className="text-body-base font-semibold leading-md text-foreground-primary">
                {label}
              </h6>
              {canOpen && (
                <Disclosure.Button
                  className="accordion-button shrink-0"
                  role="accordion-button"
                >
                  <div
                    className={clsx(
                      "transform cursor-pointer bg-transparent transition ease-linear",
                      open ? "rotate-90" : "-rotate-90",
                    )}
                    data-testid="close-button"
                  >
                    <ChevronLeft className="size-6" />
                  </div>
                </Disclosure.Button>
              )}
            </div>
            <Transition
              enter="transition duration-100 ease-out"
              enterFrom="transform scale-95 opacity-0"
              enterTo="transform scale-100 opacity-100"
              leave="transition duration-75 ease-out"
              leaveFrom="transform scale-100 opacity-100"
              leaveTo="transform scale-95 opacity-0"
            >
              <Disclosure.Panel className="accordion-body">
                <div className="accordion-body mt-4">{children}</div>
              </Disclosure.Panel>
            </Transition>
          </>
        )}
      </Disclosure>
    </div>
  );
};
